import { Icon, type IconName } from '@launchpad-ui/icons';
import cx from 'clsx';

import styles from './SignUpValueProposition.module.css';

export const SignUpValueProposition = ({
  header,
  content,
  icon = 'check',
  iconSrc,
  variant,
}: {
  header: string;
  content: string;
  icon?: IconName;
  iconSrc?: string;
  variant?: 'agentControl';
}) => {
  const isAgentControl = variant === 'agentControl';

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        {iconSrc ? (
          <img src={iconSrc} alt="" className={styles.iconImage} />
        ) : (
          <Icon name={icon} className={cx(styles.icon, isAgentControl && styles.iconDark)} />
        )}
      </div>
      <div className={styles.right}>
        <div className={cx(styles.containerSubtext, isAgentControl && styles.headerDark)}>{header}</div>
        <div className={cx(styles.subtext, isAgentControl && styles.subtextDark)}>{content}</div>
      </div>
    </div>
  );
};
